// extracted by mini-css-extract-plugin
export default {"popElement":"PopElement_popElement__EvpS7","pop":"PopElement_pop__5gPA9"};